import React, { Fragment, memo, ReactNode } from 'react';
import { IconChevronLeft } from '@app/icons';
import { Button } from 'components/ui/button';

export interface Props {
  onClickBack?: () => void;
  rightControls?: ReactNode[];
  title: string;
  leftInfo?: ReactNode[];
}

function Toolbar(props: Props) {
  const { title, onClickBack, rightControls, leftInfo } = props;

  return (
    <div className="px-4 box-border flex items-center bg-white rounded-lg h-18">
      {!!onClickBack && (
        <Button
          variant="ghost"
          size="icon"
          onClick={onClickBack}
          className="w-12 h-12 bg-[#ededed] rounded-full flex items-center justify-center border-none outline-none text-[#3a57e8] mr-4 cursor-pointer hover:bg-[#f5f5f5]"
        >
          <IconChevronLeft />
        </Button>
      )}
      <p className="font-medium text-3xl leading-9 tracking-tight text-[#0a0a0a] m-0 mr-4">
        {title}
      </p>
      {!!leftInfo && (
        <div className="flex items-center mr-auto">
          {leftInfo.map((rightControl, i) => (
            <Fragment key={i}>{rightControl}</Fragment>
          ))}
        </div>
      )}
      {!!rightControls && (
        <div className="flex items-center ml-auto">
          {rightControls.map((rightControl, i) => (
            <Fragment key={i}>{rightControl}</Fragment>
          ))}
        </div>
      )}
    </div>
  );
}

export default memo(Toolbar);
